/**
 * @flow
 * @relayHash d2779eb65d6411ec448c78c322f48cb0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PolicyEditor_document$ref = any;
type PolicyEditor_documentSave$ref = any;
type PolicyEditor_editorProperties$ref = any;
export type CreatePolicyQueryVariables = {|
  documentPk?: ?number,
  templatePk?: ?number,
  documentSavePk?: ?number,
|};
export type CreatePolicyQueryResponse = {|
  +documentCreate: ?{|
    +document: ?{|
      +pk: ?number,
      +name: string,
      +$fragmentRefs: PolicyEditor_document$ref,
    |},
    +documentSave: ?{|
      +$fragmentRefs: PolicyEditor_documentSave$ref
    |},
    +editForm: ?{|
      +name: ?string,
      +author: ?{|
        +pk: ?number,
        +firstName: string,
        +lastName: string,
        +title: ?string,
      |},
      +category: ?{|
        +pk: ?number,
        +name: string,
      |},
      +categoryChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +flowTemplate: ?{|
        +pk: ?number,
        +name: ?string,
      |},
      +flowTemplateChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: ?string,
      |}>,
      +bloc: ?{|
        +pk: ?number,
        +name: string,
      |},
      +blocChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +html: ?string,
      +activeLifespan: ?number,
      +expirationDate: ?string,
      +isAForm: ?boolean,
      +restricted: ?boolean,
      +regulations: ?$ReadOnlyArray<?number>,
      +onesourceDocuments: ?$ReadOnlyArray<?{|
        +oneSourceDocumentId: string,
        +catalogNumber: ?string,
        +manufacturerName: ?string,
        +revisionInformation: string,
        +viewUrl: ?string,
      |}>,
    |},
    +tagForm: ?{|
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>
    |},
    +saveForm: ?{|
      +hasSavedCopy: ?boolean,
      +continueDraft: ?boolean,
      +timestamp: ?string,
    |},
    +scheduledEffectiveDateForm: ?{|
      +effectiveDate: ?string,
      +effectiveDateTimedelta: ?number,
      +effectiveDateAlgorithm: ?string,
    |},
    +systemDocumentTemplateForm: ?{|
      +blocs: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>
    |},
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
    +redirectUrl: ?string,
    +policyActions: ?any,
    +canLocalize: ?boolean,
    +$fragmentRefs: PolicyEditor_editorProperties$ref,
  |}
|};
export type CreatePolicyQuery = {|
  variables: CreatePolicyQueryVariables,
  response: CreatePolicyQueryResponse,
|};
*/


/*
query CreatePolicyQuery(
  $documentPk: Int
  $templatePk: Int
  $documentSavePk: Int
) {
  documentCreate(pk: $documentPk, templatePk: $templatePk, documentSavePk: $documentSavePk) {
    document {
      pk
      name
      ...PolicyEditor_document
      id
    }
    documentSave {
      ...PolicyEditor_documentSave
      id
    }
    editForm {
      name
      author {
        pk
        firstName
        lastName
        title
        id
      }
      category {
        pk
        name
        id
      }
      categoryChoices {
        pk
        name
        id
      }
      flowTemplate {
        pk
        name
        id
      }
      flowTemplateChoices {
        pk
        name
        id
      }
      bloc {
        pk
        name
        id
      }
      blocChoices {
        pk
        name
        id
      }
      html
      activeLifespan
      expirationDate
      isAForm
      restricted
      regulations
      onesourceDocuments {
        oneSourceDocumentId
        catalogNumber
        manufacturerName
        revisionInformation
        viewUrl
        id
      }
    }
    tagForm {
      tags {
        pk
        name
        id
      }
    }
    saveForm {
      hasSavedCopy
      continueDraft
      timestamp
    }
    scheduledEffectiveDateForm {
      effectiveDate
      effectiveDateTimedelta
      effectiveDateAlgorithm
    }
    systemDocumentTemplateForm {
      blocs {
        pk
        name
        id
      }
    }
    error {
      statusCode
      message
    }
    ...PolicyEditor_editorProperties
    redirectUrl
    policyActions
    canLocalize(isCreatePage: true)
  }
}

fragment PolicyEditor_document on DocumentType {
  id
  pk
  name
  status
  actions(isEditPage: false) {
    id
    pk
    actionType
    actionDate
    comment
    canEdit
    isExternal
    user {
      id
      userDisplay(userDisplayType: FORWARD)
    }
  }
  epAssociationDocuments {
    pk
    id
  }
  systemDocumentTemplate {
    pk
    id
  }
  ...commentForm_document
  isTemplate
}

fragment PolicyEditor_documentSave on DocumentSaveType {
  pk
  savedCopy {
    pk
    author {
      pk
      firstName
      lastName
      email
      id
    }
    isTemplate
    usersNotificationComment {
      usersNotificationCommentOn {
        pk
        firstName
        lastName
        id
      }
      usersNotificationCommentOff {
        pk
        firstName
        lastName
        id
      }
    }
    id
  }
}

fragment PolicyEditor_editorProperties on DocumentEditType {
  ckeditor5
  ...editor_editorProperties
}

fragment editor_editorProperties on DocumentEditType {
  rtlSupport
  newCkeditor
  ckeditor5
  ckeditor5AiEnabled
  newSpellcheckEnabled
  newSpellcheckTenantDictionaryName
  ckeditor5LicenseKey
  contentDirection
}

fragment commentForm_document on DocumentType {
  id
  pk
  canComment
  status
  subscribedToComments
  usersNotificationComment {
    usersNotificationCommentOn {
      pk
      firstName
      lastName
      id
    }
    usersNotificationCommentOff {
      pk
      firstName
      lastName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPk",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "templatePk",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "documentSavePk",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "documentSavePk",
    "variableName": "documentSavePk",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "pk",
    "variableName": "documentPk",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "templatePk",
    "variableName": "templatePk",
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = [
  v2,
  v3
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "html",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "activeLifespan",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAForm",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regulations",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "oneSourceDocumentId",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "catalogNumber",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "manufacturerName",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionInformation",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewUrl",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "saveForm",
  "storageKey": null,
  "args": null,
  "concreteType": "DocumentSaveFormType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasSavedCopy",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "continueDraft",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }
  ]
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "scheduledEffectiveDateForm",
  "storageKey": null,
  "args": null,
  "concreteType": "ScheduledEffectiveDateForm",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateTimedelta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateAlgorithm",
      "args": null,
      "storageKey": null
    }
  ]
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "redirectUrl",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "policyActions",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canLocalize",
  "args": [
    {
      "kind": "Literal",
      "name": "isCreatePage",
      "value": true,
      "type": "Boolean"
    }
  ],
  "storageKey": "canLocalize(isCreatePage:true)"
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v26 = [
  v2,
  v25
],
v27 = [
  v2,
  v4,
  v5,
  v25
],
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "usersNotificationComment",
  "storageKey": null,
  "args": null,
  "concreteType": "UserCommentNotificationType",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "usersNotificationCommentOn",
      "storageKey": null,
      "args": null,
      "concreteType": "UserType",
      "plural": true,
      "selections": v27
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "usersNotificationCommentOff",
      "storageKey": null,
      "args": null,
      "concreteType": "UserType",
      "plural": true,
      "selections": v27
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isTemplate",
  "args": null,
  "storageKey": null
},
v30 = [
  v2,
  v3,
  v25
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CreatePolicyQuery",
  "id": "f7a6385c43301aacd54e68070edcef08",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CreatePolicyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentCreate",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentEditType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "FragmentSpread",
                "name": "PolicyEditor_document",
                "args": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentSave",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentSaveType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PolicyEditor_documentSave",
                "args": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentFormType",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v2,
                  v4,
                  v5,
                  v6
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v7
              },
              v8,
              v9,
              v10,
              v11,
              v12,
              v13,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v14,
                  v15,
                  v16,
                  v17,
                  v18
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v7
              }
            ]
          },
          v19,
          v20,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "systemDocumentTemplateForm",
            "storageKey": null,
            "args": null,
            "concreteType": "SystemDocumentTemplateFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocs",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v7
              }
            ]
          },
          v21,
          {
            "kind": "FragmentSpread",
            "name": "PolicyEditor_editorProperties",
            "args": null
          },
          v22,
          v23,
          v24
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CreatePolicyQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentCreate",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentEditType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v2,
              v3,
              v25,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "actions",
                "storageKey": "actions(isEditPage:false)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "isEditPage",
                    "value": false,
                    "type": "Boolean"
                  }
                ],
                "concreteType": "DocumentActionType",
                "plural": true,
                "selections": [
                  v25,
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actionType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "actionDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "comment",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canEdit",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isExternal",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": false,
                    "selections": [
                      v25,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "userDisplay",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "userDisplayType",
                            "value": "FORWARD",
                            "type": "UserDisplayType"
                          }
                        ],
                        "storageKey": "userDisplay(userDisplayType:\"FORWARD\")"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "epAssociationDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "EpAssociationDocumentType",
                "plural": true,
                "selections": v26
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v26
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canComment",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subscribedToComments",
                "args": null,
                "storageKey": null
              },
              v28,
              v29
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documentSave",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentSaveType",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "savedCopy",
                "storageKey": null,
                "args": null,
                "concreteType": "RLDatixDocumentType",
                "plural": false,
                "selections": [
                  v2,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "author",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": false,
                    "selections": [
                      v2,
                      v4,
                      v5,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                      },
                      v25
                    ]
                  },
                  v29,
                  v28,
                  v25
                ]
              },
              v25
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentFormType",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v2,
                  v4,
                  v5,
                  v6,
                  v25
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v30
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v30
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v30
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v30
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v30
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v30
              },
              v8,
              v9,
              v10,
              v11,
              v12,
              v13,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v14,
                  v15,
                  v16,
                  v17,
                  v18,
                  v25
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v30
              }
            ]
          },
          v19,
          v20,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "systemDocumentTemplateForm",
            "storageKey": null,
            "args": null,
            "concreteType": "SystemDocumentTemplateFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocs",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v30
              }
            ]
          },
          v21,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ckeditor5",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rtlSupport",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "newCkeditor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ckeditor5AiEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "newSpellcheckEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "newSpellcheckTenantDictionaryName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ckeditor5LicenseKey",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contentDirection",
            "args": null,
            "storageKey": null
          },
          v22,
          v23,
          v24
        ]
      }
    ]
  }
};
})();
node.text = "query CreatePolicyQuery(\n  $documentPk: Int\n  $templatePk: Int\n  $documentSavePk: Int\n) {\n  documentCreate(pk: $documentPk, templatePk: $templatePk, documentSavePk: $documentSavePk) {\n    document {\n      pk\n      name\n      ...PolicyEditor_document\n      id\n    }\n    documentSave {\n      ...PolicyEditor_documentSave\n      id\n    }\n    editForm {\n      name\n      author {\n        pk\n        firstName\n        lastName\n        title\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      categoryChoices {\n        pk\n        name\n        id\n      }\n      flowTemplate {\n        pk\n        name\n        id\n      }\n      flowTemplateChoices {\n        pk\n        name\n        id\n      }\n      bloc {\n        pk\n        name\n        id\n      }\n      blocChoices {\n        pk\n        name\n        id\n      }\n      html\n      activeLifespan\n      expirationDate\n      isAForm\n      restricted\n      regulations\n      onesourceDocuments {\n        oneSourceDocumentId\n        catalogNumber\n        manufacturerName\n        revisionInformation\n        viewUrl\n        id\n      }\n    }\n    tagForm {\n      tags {\n        pk\n        name\n        id\n      }\n    }\n    saveForm {\n      hasSavedCopy\n      continueDraft\n      timestamp\n    }\n    scheduledEffectiveDateForm {\n      effectiveDate\n      effectiveDateTimedelta\n      effectiveDateAlgorithm\n    }\n    systemDocumentTemplateForm {\n      blocs {\n        pk\n        name\n        id\n      }\n    }\n    error {\n      statusCode\n      message\n    }\n    ...PolicyEditor_editorProperties\n    redirectUrl\n    policyActions\n    canLocalize(isCreatePage: true)\n  }\n}\n\nfragment PolicyEditor_document on DocumentType {\n  id\n  pk\n  name\n  status\n  actions(isEditPage: false) {\n    id\n    pk\n    actionType\n    actionDate\n    comment\n    canEdit\n    isExternal\n    user {\n      id\n      userDisplay(userDisplayType: FORWARD)\n    }\n  }\n  epAssociationDocuments {\n    pk\n    id\n  }\n  systemDocumentTemplate {\n    pk\n    id\n  }\n  ...commentForm_document\n  isTemplate\n}\n\nfragment PolicyEditor_documentSave on DocumentSaveType {\n  pk\n  savedCopy {\n    pk\n    author {\n      pk\n      firstName\n      lastName\n      email\n      id\n    }\n    isTemplate\n    usersNotificationComment {\n      usersNotificationCommentOn {\n        pk\n        firstName\n        lastName\n        id\n      }\n      usersNotificationCommentOff {\n        pk\n        firstName\n        lastName\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment PolicyEditor_editorProperties on DocumentEditType {\n  ckeditor5\n  ...editor_editorProperties\n}\n\nfragment editor_editorProperties on DocumentEditType {\n  rtlSupport\n  newCkeditor\n  ckeditor5\n  ckeditor5AiEnabled\n  newSpellcheckEnabled\n  newSpellcheckTenantDictionaryName\n  ckeditor5LicenseKey\n  contentDirection\n}\n\nfragment commentForm_document on DocumentType {\n  id\n  pk\n  canComment\n  status\n  subscribedToComments\n  usersNotificationComment {\n    usersNotificationCommentOn {\n      pk\n      firstName\n      lastName\n      id\n    }\n    usersNotificationCommentOff {\n      pk\n      firstName\n      lastName\n      id\n    }\n  }\n}\n";
(node/*: any*/).hash = 'c6853696fb7820bcd50087e851cbfca8';
module.exports = node;
